import API from 'API';

export const create = (schedule) => API.save('schedules/', schedule);

export const findAllSchedules = async () => await API.find('schedules/');

export const findScheduleById = async (id) => API.find(`schedules/${id}`);

export const findScheduleStepsById = async (id) =>
  API.find(`schedules/${id}/scheduleSteps`);

export const validateUniqueScheduleName = async (title, id) => {
  if (!title) {
    return 'Name is required';
  } else if (
    await API.find(`schedules/validateScheduleUniqueName`, {title, id})
  ) {
    return 'Name already exists';
  } else {
    return '';
  }
};
